import avalonInverter from '../assets/equipment/avalon-inverter.png';
import smartEnergyPanel from '../assets/equipment/smart-energy-panel.png';
import avalon from '../assets/equipment/avalon.png';
import hvBattery from '../assets/equipment/hv-battery.png';
import eflex from '../assets/equipment/eflex.png';
import fpEnvyInverter from '../assets/equipment/fp-envy-inverter.png';
import evault from '../assets/equipment/evault.png';

import { EquipmentData, EquipmentPortfolioType, Equipment } from 'src/models';

type EquipmentInfo = {
  image: string;
  type: string;
};

const equipmentMap: Record<string, EquipmentInfo> = {
  'Avalon Inverter 11.4': { image: avalonInverter, type: 'Inverter' },
  'Avalon Inverter 7.6': { image: avalonInverter, type: 'Inverter' },
  'Smart Energy Panel': { image: smartEnergyPanel, type: 'Energy Panel' },
  'Avalon HV BMS': { image: avalon, type: 'Battery Mgmt System' },
  'HV Battery': { image: hvBattery, type: 'Battery' },
  eFlex: { image: eflex, type: 'Battery' },
  eFlexRevB: { image: eflex, type: 'Battery' },
  'FP-ENVY-Inverter': { image: fpEnvyInverter, type: 'Inverter' },
  eVaultMaxRevB: { image: evault, type: 'Battery' },
};

const getEquipmentType = (model: string): string => {
  return equipmentMap[model]?.type || '';
};

const getEquipmentImage = (model: string): string => {
  return equipmentMap[model]?.image || '';
};

export const formatPortfolioEquipment = (data: EquipmentData[]): EquipmentPortfolioType[] => {
  const groupedByModel = data.reduce<Record<string, { count: number; type: string }>>(
    (acc, item) => {
      const model = item.model;
      if (!model) {
        return acc;
      }
      if (!acc[model]) {
        acc[model] = {
          count: 0,
          type: getEquipmentType(model),
        };
      }
      acc[model].count++;
      return acc;
    },
    {}
  );

  return Object.entries(groupedByModel).map(
    ([model, info]): EquipmentPortfolioType => ({
      image: getEquipmentImage(model),
      model,
      quantity: info.count,
      type: info.type,
    })
  );
};

export const formatDashboardEquipment = (data: Equipment[][]): EquipmentPortfolioType[][] =>
  data.map((equipment) => formatPortfolioEquipment(equipment as EquipmentData[]));
